(() => {
  'use strict';

  const selector = '[data-xifun-dark-hero]';
  const controllers = new Map();

  class XifunDarkHero {
    constructor(section) {
      this.section = section;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onModeChange = this.updateVideo.bind(this);
    }

    init() {
      if (this.section.dataset.xifunInitialized === 'true') return;
      this.section.dataset.xifunInitialized = 'true';
      if (this.section.dataset.animate === 'true' && !this.reducedQuery.matches) {
        this.section.classList.add('is-entering');
      }
      this.mobileQuery.addEventListener('change', this.onModeChange);
      this.reducedQuery.addEventListener('change', this.onModeChange);
      this.updateVideo();
    }

    updateVideo() {
      const mode = this.mobileQuery.matches ? 'mobile' : 'desktop';
      this.section.querySelectorAll('[data-xifun-hero-video]').forEach((video) => {
        const active = video.dataset.xifunHeroVideo === mode && !this.reducedQuery.matches;
        if (!active) {
          video.pause();
          video.classList.remove('is-playing');
          return;
        }
        if (video.dataset.loaded !== 'true') {
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.dataset.loaded = 'true';
          video.load();
        }
        const promise = video.play();
        if (promise?.then) promise.then(() => video.classList.add('is-playing')).catch(() => {});
      });
    }

    destroy() {
      this.mobileQuery.removeEventListener('change', this.onModeChange);
      this.reducedQuery.removeEventListener('change', this.onModeChange);
      this.section.querySelectorAll('video').forEach((video) => video.pause());
      delete this.section.dataset.xifunInitialized;
      controllers.delete(this.section);
    }
  }

  const init = (scope = document) => {
    const sections = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    sections.forEach((section) => {
      if (controllers.has(section)) return;
      const controller = new XifunDarkHero(section);
      controllers.set(section, controller);
      controller.init();
    });
  };

  if (!window.__xifunDarkHeroLoaded) {
    window.__xifunDarkHeroLoaded = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      controllers.get(event.target)?.destroy();
    });
    window.addEventListener('pageshow', () => init());
  }

  init();
})();
